/**
 * @generated SignedSource<<ff7ed5cbec8e325e2d5e324ffc9890a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useGetRequiredWizardSteps$data = {
  readonly member: {
    readonly club: {
      readonly clients: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id?: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    };
    readonly id?: string;
    readonly repeatableBookings?: ReadonlyArray<{
      readonly id: string;
      readonly rounds: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly player: {
              readonly id: string;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"BookingCard_Booking">;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useGetRequiredWizardSteps";
};
export type useGetRequiredWizardSteps$key = {
  readonly " $data"?: useGetRequiredWizardSteps$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetRequiredWizardSteps">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "dateLte",
      "variableName": "currentDate"
    },
    {
      "kind": "Variable",
      "name": "forSlotId",
      "variableName": "forSlotId"
    },
    {
      "kind": "Variable",
      "name": "slotType",
      "variableName": "slotType"
    }
  ],
  "concreteType": null,
  "kind": "LinkedField",
  "name": "repeatableBookings",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "RoundConnection",
      "kind": "LinkedField",
      "name": "rounds",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoundEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "player",
                  "plural": false,
                  "selections": (v1/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingCard_Booking"
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "currentDate"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "forSlotId"
    },
    {
      "kind": "RootArgument",
      "name": "players"
    },
    {
      "kind": "RootArgument",
      "name": "slotType"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetRequiredWizardSteps",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "member",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v2/*: any*/)
          ],
          "type": "Member",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v0/*: any*/),
            (v2/*: any*/)
          ],
          "type": "Customer",
          "abstractKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Club",
          "kind": "LinkedField",
          "name": "club",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "active",
                  "value": true
                },
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 25
                },
                {
                  "kind": "Variable",
                  "name": "players",
                  "variableName": "players"
                }
              ],
              "concreteType": "ClientConnection",
              "kind": "LinkedField",
              "name": "clients",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ClientEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": (v1/*: any*/),
                          "type": "Member",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": (v1/*: any*/),
                          "type": "Customer",
                          "abstractKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ClientProfile",
  "abstractKey": "__isClientProfile"
};
})();

(node as any).hash = "40e50da2ef432cb6bc4241c8ff357a49";

export default node;
